import type { UserStateMap } from '../../types/user-state';
import type { Job } from '../../types/tracked-job';
import { userStateEntryToJob } from '../user-state/extract-jobs-from-user-state';

export type TrackedJobItemKey =
  | `viewedJob#${string}`
  | `savedJob#${string}`
  | `appliedJob#${string}`;

/**
 * Which user-state bucket holds this job (applied wins over saved over viewed).
 * Used when upserting fields like `isHidden` onto the correct `*Job#` entry.
 */
export function resolveTrackedJobRef(
  jobId: string,
  userState: UserStateMap | undefined,
): { itemKey: TrackedJobItemKey; job: Job } | null {
  if (!userState) return null;
  const appliedJob = userStateEntryToJob(userState[`appliedJob#${jobId}`]);
  if (appliedJob) return { itemKey: `appliedJob#${jobId}`, job: appliedJob };
  const savedJob = userStateEntryToJob(userState[`savedJob#${jobId}`]);
  if (savedJob) return { itemKey: `savedJob#${jobId}`, job: savedJob };
  const viewedJob = userStateEntryToJob(userState[`viewedJob#${jobId}`]);
  if (viewedJob) return { itemKey: `viewedJob#${jobId}`, job: viewedJob };
  return null;
}

export function timestampExtrasFromJob(job: Job): Record<string, unknown> {
  const r = job as Record<string, unknown>;
  const o: Record<string, unknown> = {};
  if (r.viewedAt) o.viewedAt = r.viewedAt;
  if (r.savedAt) o.savedAt = r.savedAt;
  if (r.appliedAt) o.appliedAt = r.appliedAt;
  return o;
}
